<template>
    <div class="wrapper">
     <div class="type">
        <div class="type-top">
          <div class="type-top-left"></div>
          医疗器械经营许可证
        </div>
        <div class="type-text">
          <div class="CodeText">
            许可证编号： <span>{{ RejectListProps.BusLicenceCode }}</span>
          </div>
          <div class="CodeText">
            企业名称： <span>{{ RejectListProps.BusCompanyName }}</span>
          </div>
          <div class="CodeText">
            经营方式： <span>{{ RejectListProps.BusBusinessMode }}</span>
          </div>
          <div class="CodeText">
            住所： <span>{{ RejectListProps.BusAddress }}</span>
          </div>
          <div class="CodeText">
            经营场所： <span>{{ RejectListProps.BusBusinessAddr }}</span>
          </div>
          <div class="CodeText">
            库房地址： <span>{{ RejectListProps.BusWarehouseAddr }}</span>
          </div>
          <div class="CodeText">
            注册地址： <span>{{ RejectListProps.BusRegisterAddr }}</span>
          </div>
          <div class="CodeText">
            法定代表人： <span>{{ RejectListProps.BusLegalRepresentative }}</span>
          </div>
          <div class="CodeText">
            企业负责人： <span>{{ RejectListProps.BusCEO }}</span>
          </div>
          <div class="CodeText">
            经营范围： <span>{{ RejectListProps.BusThirdInvSort }}</span>
          </div>
          <div class="CodeText">
            发证日期： <span>{{ RejectListProps.BusIssueDate }}</span>
          </div>
          <div class="CodeText">
            起始日期： <span>{{ RejectListProps.BusStartDate }}</span>
          </div>
          <div class="CodeText">
            失效日期： <span>{{ RejectListProps.BusEndDate }}</span>
          </div>
          <div class="CodeText">
            提交时间： <span>{{ RejectListProps.CreateTime }}</span>
          </div>
          <div class="CodeText">
            审核时间： <span>{{ RejectListProps.VerifyTime }}</span>
          </div>
          <div class="CodeText">
            驳回时间： <span>{{ RejectListProps.RejectTime }}</span>
          </div>
          <div class="CodeText">
            医疗器械经营许可证
            <div class="imgBox">
              <!-- ${ config.http_URL } + -->
              <img :src="`${RejectListProps.BusPhotoURL}`">
            </div>
            <div class="imgTop4"><img src="../../../../../assets/channel/firstbusiness/phontsD.png" alt="" class="imgPhoto" @click="imgShowClick(RejectListProps.BusPhotoURL)"></div>
          </div>

          <div class="CodeText">
            驳回原因： <span>{{ RejectListProps.RejectReason }}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    components:{},
    props:{
        RejectListProps: {
            type: Object
        }
    },
    data(){
      return {

      }
    },
    created(){},
    mounted(){},
    activated(){},
    updated(){},
    methods:{
        imgShowClick(URL) {
            this.$emit('imgShowClick',URL)
        }
    },
    computed:{},
    watch:{},
  }
</script>
<style scoped lang='less'>
@import url('../index.less');
</style>